import { createSlice } from '@reduxjs/toolkit';

import { User } from 'types/user';
import { resetStoresAction } from 'common/actions/common';

type UserState = {
  isFetching: boolean;
  user: User | {};
  error: string;
};

export type UserPartialState = {
  user: UserState;
};

const defaultState: UserState = {
  isFetching: false,
  user: {},
  error: '',
};

const setFetching = (state: UserState): UserState => ({
  ...state,
  isFetching: true,
  error: '',
});

const handleSuccess = (state: UserState, { payload }): UserState => ({
  ...state,
  isFetching: false,
  user: payload,
  error: '',
});

const user = createSlice({
  name: 'user',
  initialState: defaultState,
  reducers: {
    userUpdateAction: setFetching,
    userUpdateSuccessAction: handleSuccess,
    userUpdateFailedAction: (state, { payload }) => ({
      ...state,
      isFetching: false,
      error: payload,
    }),
  },
  extraReducers: (builder) =>
    builder.addCase(resetStoresAction, () => defaultState),
});

export const {
  userUpdateAction,
  userUpdateSuccessAction,
  userUpdateFailedAction,
} = user.actions;

export default user.reducer;
